"use client";

/**
 * /book — the unified booking flow (Phase 3 cutover, 2026-05-02).
 *
 * Previously this file was a feature-flag gate that rendered either
 * <UnifiedBookPage> or <LegacyBookPage> depending on
 * `siteConfig.unifiedBookingFlow`. The unified flow has been live
 * for a month with no regressions, so we collapsed the chooser and
 * deleted LegacyBookPage. The flag still exists on SiteConfig (now
 * unread) — leaving it there means existing prod rows stay valid
 * even though it's a no-op.
 *
 * If you ever need to roll back: git revert this commit + restore
 * LegacyBookPage.tsx from history.
 */

import UnifiedBookPage from "./UnifiedBookPage";

export default function BookPage() {
  return <UnifiedBookPage />;
}
